if (typeof CollectionInfiniteScroll !== 'function') {

  class CollectionInfiniteScroll extends HTMLElement {

    constructor() {
      super();
      this.isLoading = false;
      this.observer = null;
    }

    connectedCallback() {
      this.grid = document.getElementById(this.dataset.gridId || 'main-collection-product-grid');
      if (!this.grid || !this.dataset.nextUrl) {
        this.remove();
        return;
      }

      this.status = this.querySelector('[data-infinite-scroll-status]');
      this.startObserver();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    startObserver() {
      if (!('IntersectionObserver' in window)) {
        this.loadNextPage();
        return;
      }

      this.observer?.disconnect();
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.loadNextPage();
        }
      }, { rootMargin: '0px 0px 500px 0px' });

      this.observer.observe(this);
    }

    loadNextPage() {
      if (this.isLoading || !this.dataset.nextUrl) return;

      this.isLoading = true;
      this.classList.add('is-loading');
      if (this.status) this.status.textContent = 'Loading more products';

      const url = new URL(this.dataset.nextUrl, window.location.origin);
      url.searchParams.set('section_id', this.dataset.sectionId || this.grid.dataset.id);

      fetch(url.toString(), { credentials: 'same-origin' })
        .then(response => response.ok ? response.text() : Promise.reject(response))
        .then(html => this.appendPage(html))
        .catch(() => {
          if (this.status) this.status.textContent = '';
        })
        .finally(() => {
          this.isLoading = false;
          this.classList.remove('is-loading');
        });
    }

    appendPage(html) {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const nextGrid = parsed.getElementById(this.dataset.gridId || 'main-collection-product-grid');
      if (!nextGrid) return;

      nextGrid.querySelectorAll('[data-js-product-item]').forEach(item => {
        this.grid.insertBefore(item, this);
      });

      const nextLoader = nextGrid.querySelector('collection-infinite-scroll[data-next-url]');
      if (nextLoader?.dataset.nextUrl) {
        this.dataset.nextUrl = nextLoader.dataset.nextUrl;
        if (this.status) this.status.textContent = '';
      } else {
        this.dataset.nextUrl = '';
        this.observer?.disconnect();
        this.remove();
      }
    }

  }

  if (typeof customElements.get('collection-infinite-scroll') === 'undefined') {
    customElements.define('collection-infinite-scroll', CollectionInfiniteScroll);
  }

}
